/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression -- needs manual remediation */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';

import { token } from '@atlaskit/tokens';

import {
	IMAGE_SECTION_WIDTH_REGULAR,
	IMAGE_SECTION_WIDTH_WIDE,
	TEAM_DATA_SECTION_WIDTH_REGULAR,
	TEAM_DATA_SECTION_WIDTH_WIDE,
} from './constants';
import type { ImageSectionProps, TeamDataSectionProps } from './types';

// Aliases for backward compatibility with styled-components
const WIDE = IMAGE_SECTION_WIDTH_WIDE;
const REGULAR = IMAGE_SECTION_WIDTH_REGULAR;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const IllustratedDialogContent = styled.div`
	display: flex;
	height: 100%;
	flex-direction: row;
	position: relative;
	z-index: 10;
	margin-top: ${token('space.150', '12px')};
	@media (max-width: 750px) {
		flex-direction: column;
	}
`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const SvgWrapper = styled.div<{ wide?: boolean }>`
	width: ${({ wide }) => (wide ? WIDE : REGULAR)}px;
	height: auto;
`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ImageSection = styled.div<ImageSectionProps>`
	display: flex;
	flex-direction: column;
	align-self: flex-start;
	align-items: center;
	min-width: 0; /* Hack to prevent flex-box growth: https://css-tricks.com/flexbox-truncated-text/ */
	text-align: center;
	flex: ${({ imageProportion }) => imageProportion ?? 1};
	flex-basis: ${({ wide }) => (wide ? WIDE : REGULAR)}px;
	margin-right: ${token('space.300', '24px')};
	@media (max-width: 750px) {
		margin-right: ${token('space.0', '0px')};
		margin-bottom: ${token('space.200', '16px')};
		align-self: center;
	}
`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const TeamDataSection = styled.div<TeamDataSectionProps>`
	min-width: 0; /* Hack to prevent flex-box growth: https://css-tricks.com/flexbox-truncated-text/ */
	flex: ${({ descriptionProportion }) => descriptionProportion ?? 1};
	flex-basis: ${({ wide }) =>
		wide ? TEAM_DATA_SECTION_WIDTH_WIDE : TEAM_DATA_SECTION_WIDTH_REGULAR}px;
	@media (max-width: 750px) {
		margin-left: ${token('space.0', '0px')};
	}
`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const DescriptionParagraph = styled.p`
	white-space: pre-line;
	margin-bottom: ${token('space.200', '16px')};
`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const TeamNameWrapper = styled.div`
	margin-bottom: ${token('space.200', '16px')};
`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const UserPickerWrapper = styled.div`
	margin-bottom: ${token('space.200', '16px')};
`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const InfoIconWrapper = styled.span`
	margin: 0;
	margin-left: ${token('space.050', '4px')};
	max-height: ${token('space.200', '16px')};
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles
export const DivWrapper = styled.div`
	display: flex;
	align-items: center;
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const InfoPopupLearnMoreWrapper = styled.div`
	display: block;
	margin-top: ${token('space.100', '8px')};
`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const AccessLockSVGWrapper = styled.div`
	margin-bottom: ${token('space.600', '48px')};
`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ActionButtonWrapper = styled.div`
	margin-top: ${token('space.100', '8px')};
`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ProductSelectorWrapper = styled.div`
	margin-bottom: ${token('space.200', '16px')};
`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ProductSelectorFieldLabelWrapper = styled.span`
	display: flex;
`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ProductSelectorFieldLabelContent = styled.span`
	display: flex;
	align-items: center;
	margin-left: ${token('space.050', '4px')};
`;
